import React, {useEffect} from "react";
import {Preloader} from "./pages/start-page";
import {InvestorPage} from "./pages/investor-page";
import {AdminPage} from "./pages/admin";
import {WalletConnect} from "./pages/start-page";
import {getCampaignContract} from "./utils";
import {useWeb3React} from "@web3-react/core";
import { BalanceActivationPage } from "./pages/balance-activation-page";

export function getTokenFromLocationHash() {
    return window.location.hash.replace("#", "");
}

export const App: React.FC = () => {
    const [language, setLanguage] = React.useState('en')//navigator.language)

    const [walletConnecting, setWalletConnecting] = React.useState(false)
    const [admin, setAdmin] = React.useState<boolean>()
    const { active, account, library, connector, activate, setError, deactivate } = useWeb3React()

    const balanceActivationToken = getTokenFromLocationHash()

    useEffect(() => {
        // setWalletConnecting(true)
        //     setWalletConnecting(false)
        if (account) {
            getCampaignContract(library).then(async (contract) => {
                const adminAddress = await contract.owner()
                setAdmin(adminAddress === account)
            })
        }
    }, [account])

    return (
        <>
            { walletConnecting && (
                <div>
                    <Preloader language={language}/>
                </div>
            )}
            { !account && !walletConnecting && (
                <div>
                    <WalletConnect language={language}/>
                </div>
            )}
            { account && admin === true && (
                <div>
                    <AdminPage/>
                </div>
            )}
            { account && admin === false && !balanceActivationToken && (
                <div>
                    <InvestorPage walletAddress={account} language={language}/>
                </div>
            )}
            { account && admin === false && balanceActivationToken && (
                <div>
                    <BalanceActivationPage language={language}/>
                </div>
            )}
        </>
    )
}
